import { render, staticRenderFns, recyclableRender, components } from "./u-checkbox.vue?vue&type=template&id=c4a74aee&scoped=true&"
var renderjs
import script from "./u-checkbox.vue?vue&type=script&lang=js&"
export * from "./u-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./u-checkbox.vue?vue&type=style&index=0&id=c4a74aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a74aee",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-checkbox/u-checkbox.vue"
export default component.exports